// extracted by mini-css-extract-plugin
export default {"cls1":"y8h4nkMRmZluihwDHpCO","cls2":"X41hzxHDfwwydWkWoQc_ y8h4nkMRmZluihwDHpCO"};